import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './ProductSingle.css';
import './Stylist.css';
import Header from './common/Header';
import { formattedPrice } from '../utils/priceFormatter';

const productsMap = {
    1: {
        id: 1,
        name: 'Kate 21',
        price: 12000,
        services: [
            { name: "Lorem Ipsum is simply dummy text of the printing" },
            { name: "Lorem Ipsum has been the industry's standard" },
            { name: "It has survived not only five centuries, but also" }
        ],
        about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
        description: 'Эти образы подобраны стилистом @kate21',
        imageUrl: 'https://take-two.ru/wp-content/uploads/IMG_1448-scaled.jpg',
        images: [
            'https://take-two.ru/wp-content/uploads/IMG_1448-scaled.jpg',
            'https://take-two.ru/wp-content/uploads/72278641.jpg',
            'https://static.insales-cdn.com/images/products/1/3365/813075749/29.01_%D0%A8%D1%82%D0%A86025_result.jpg',
        ]
    }
    // Add more products as needed
};

function StylistSinglePage() {
    const { productId } = useParams();
    const [product, setProduct] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const fetchProduct = async () => {
            const fetchedProduct = productsMap[productId] ?? productsMap[1];
            setProduct(fetchedProduct);
        };

        fetchProduct();
    }, [productId]);

    const handleImageClick = (event) => {
        const { clientX, target } = event;
        const targetRect = target.getBoundingClientRect();
        const clickX = clientX - targetRect.left;

        if (clickX < targetRect.width / 2) {
            // Clicked on the left part of the image
            setCurrentImageIndex((prevIndex) =>
                prevIndex > 0 ? prevIndex - 1 : product.images.length - 1
            );
        } else {
            // Clicked on the right part of the image
            setCurrentImageIndex((prevIndex) =>
                prevIndex < product.images.length - 1 ? prevIndex + 1 : 0
            );
        }
    };

    if (!product) {
        // return <div>Loading...</div>;
        return <div></div>;
    }

    return (
        <div>
            <Header />
            <main className="">
                <section className="product-single-section">
                    <div className="product-single-images">
                        <div className="product-single-image-list">
                            {product.images.map((image, index) => (
                                <img key={index} src={image} alt={`Default ${index + 1}`} />
                            ))}
                        </div>
                    </div>
                    <div className="product-single-main-image" onClick={handleImageClick}>
                        <img src={product?.images[currentImageIndex]} alt="Main" />
                        <div className="name">
                            {product.name}
                        </div>
                        <div className="name description">
                            {product.description}
                        </div>
                        <div className="subscribe">
                            <button className="add-to-cart-button">Подписаться</button>
                        </div>
                    </div>

                    <div className="about">
                        <h2>About</h2>
                        <div>{product.about}</div>
                    </div>

                    <div className="services">
                        <h2>Услуги</h2>
                        <div>
                            {product.services.map((service, index) => (
                                <div key={index} className={`service-item ${index === 0 ? "first-service" : ""}`}>
                                    <div className="service-number">{index + 1}</div>
                                    <div className="service-name">{service.name}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* <div className="product-single-info stylist">
                        <p>{product.description}</p>
                        <p className="price">{formattedPrice(product.price, product.actual_price, product.sale)}</p>
                        <button className="add-to-cart-button">Совместный шоппинг</button>
                    </div> */}
                </section>
            </main>
        </div>
    );
}

export default StylistSinglePage;
